import { seriesSvgMulti, AnySeries } from '@d3fc/d3fc-series';
import { PortfolioPosition } from 'portfolio/PortfolioSelection';
import gridlines from 'utils/components/TimeSeriesChart/gridlines';
import { OrderFill } from '../../fillsGraphData';
import { fillPercentArea } from './fillPercentArea';
import { fillVolumeBars } from './fillVolumeBars';
import { averageExecutionLine } from './averageExecutionLine';
import { vwapLine } from './vwapLine';
import { priceLine } from './priceLine';
import { fillPricePoints } from './fillPricePoints';
import { createArriveCloseLine } from './arrivalAndCloseAndOpenLines.ts';
import { createLimitPriceSeries } from './limitPriceLine';
import { indexLine } from './indexLine';
import { priceCandlesSeries } from 'widgets/fillsGraph/orderFills/series/priceCandle';

export const orderFillsSeries = (
    yStart: number,
    yEnd: number,
    yTicks: number,
    snapPrice: number | undefined,
    closePrice: number | undefined,
    openPrice: number | undefined,
    orderQuantity: number | undefined,
    position: PortfolioPosition | undefined,
    limitPriceAccessor: (d: OrderFill) => number | undefined
) => {
    const limitPriceSeries = createLimitPriceSeries(
        yStart,
        yEnd,
        position,
        limitPriceAccessor
    );

    return seriesSvgMulti()
        .series([
            gridlines(yTicks),
            fillPercentArea(yStart, yEnd),
            fillVolumeBars(orderQuantity),
            priceLine,
            priceCandlesSeries,
            vwapLine,
            averageExecutionLine(),
            indexLine,
            fillPricePoints(),
            createArriveCloseLine('Arrival', snapPrice),
            createArriveCloseLine('Close', closePrice),
            createArriveCloseLine('Open', openPrice),
            limitPriceSeries,
        ])
        .mapping((data: OrderFill[], index: number, series: AnySeries[]) => {
            switch (series[index]) {
                case limitPriceSeries:
                    return data.filter(
                        (d) => limitPriceAccessor(d) !== undefined
                    );
                default:
                    return data;
            }
        });
};
